var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[(_vm.guestsFetched && _vm.backendHealthy)?_c('RSVP'):(_vm.backendHealthy)?_c('InviteSearch'):_c('Fallback')],1)}
var staticRenderFns = []

export { render, staticRenderFns }